<template>
  <div class="flex items-center">


    <div class="ml-2">
      <a :href="'https://coach.getboarded.com/user/my-rater/rater-list?userId='+this.params.data.id+'&traineeName='+this.params.data.firstName+' '+this.params.data.lastName">Rater Details</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CellRendererEmail',
    computed: {
      textColor () {
        return this.params.data.isVerified ? 'text-primary' : 'text-grey'
      }
    }
  }
</script>

<style scoped>

</style>
